import { render, staticRenderFns } from "./UiCardListItem.vue?vue&type=template&id=b7415a08&scoped=true&"
import script from "./UiCardListItem.vue?vue&type=script&lang=js&"
export * from "./UiCardListItem.vue?vue&type=script&lang=js&"
import style0 from "./UiCardListItem.vue?vue&type=style&index=0&id=b7415a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7415a08",
  null
  
)

export default component.exports